
import actions from './responseHandling.types'

const initialState = {
  loading: false,
  errMsg: ""
}

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
